import { EmptyTablePlaceholder } from '@openx/components-core/lib/TablePlaceholder/EmptyTablePlaceholder';
import { Table, TableName } from '@openx/components-table/Table';
import type { Account } from '@openx/types/account';
import type { AllTableCriteria, ChangeCriteriaHandler, CriteriaDimension } from '@openx/types/tableCriteria';
import type { UserList } from '@openx/types/user';

import type { UsersListFilters } from '../../types';
import { useAdministrationContext } from '../utils/context/AdministrationContext';

import { UsersTopBar } from './UsersTopBar';

type Props = {
  criteria: AllTableCriteria;
  handleCriteriaChange: ChangeCriteriaHandler<CriteriaDimension>;
  handleFiltersChange: (filters: { dimension: typeof CriteriaDimension.FILTERS; value: UsersListFilters }) => void;
  loading: boolean;
  users: UserList[];
};
export const UsersList = ({ criteria, loading, users, handleCriteriaChange, handleFiltersChange }: Props) => {
  const { useGetUsersTableData, useAccountOptionsFetch } = useAdministrationContext();
  const { accounts } = useAccountOptionsFetch();

  const { columns, filtersConfig, rowActions } = useGetUsersTableData(
    accounts.list as Account[],
    (criteria.filters as UsersListFilters).phrase ?? ''
  );

  const isTableEmpty = !loading && !criteria.filters && users.length === 0;

  return (
    <>
      <UsersTopBar
        filtersConfig={filtersConfig}
        filters={criteria.filters as UsersListFilters}
        onChange={handleFiltersChange}
      />

      {isTableEmpty ? (
        <EmptyTablePlaceholder />
      ) : (
        <Table
          name={TableName.USERS}
          data={users}
          columns={columns}
          criteria={criteria}
          loading={loading}
          onCriteriaChange={handleCriteriaChange}
          rowActions={rowActions}
        />
      )}
    </>
  );
};
